export class Catalog {
    id: string = "";
    name: string = "";
    description: string = "";
    notes: string = "";

    quantity: number = 0;
    deleted: boolean = false;

    products: string[];
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/catalogs/catalog.ts